<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
    import Dialog from '../Dialog.svelte';
    import { default as defaultButtons } from './dialogButtons';

    export let heading;
    export let message;
    export let icon = '';
    export let iconStatus = 'neutral';
    export let headingCentered = false;
    export let buttonsAlignment = 'end';

    const buttons = [defaultButtons.cancel, defaultButtons.ok];
</script>

<Dialog
    mode="modal"
    {heading}
    {message}
    {buttons}
    {buttonsAlignment}
    {headingCentered}
    {icon}
    {iconStatus}
    on:action
    on:close
>
    <slot></slot>
</Dialog>
